import { useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FJHorizontalScrollTab from '../../FJTab/FJHorizontalScrollTab';
import styles from './FJModelFilterTabs.module.less';

const FJModelFilterTabs = ({ show = true, filters, activeFilter, onChange }) => {
    const tabRef = useRef(null);

    useEffect(() => {
        if (show) {
            tabRef.current.updateArrowState && tabRef.current.updateArrowState();
        }
    }, [show]);

    // 转换为 FJHorizontalScrollTab 需要的 dataList 格式
    const dataList = useMemo(() => {
        return filters.map(filter => ({
            type: filter.value,
            text: filter.label,
        }));
    }, [filters]);

    // 找到当前选中项的索引
    const selectedIndex = useMemo(() => {
        const index = filters.findIndex(filter => filter.value === activeFilter);
        return index >= 0 ? index : 0;
    }, [filters, activeFilter]);

    // 处理 tab 切换，将索引转换为 value
    const handleTabChange = index => {
        if (filters[index]) {
            onChange(filters[index].value);
        }
    };

    return (
        <FJHorizontalScrollTab
            ref={tabRef}
            dataList={dataList}
            selectedIndex={selectedIndex}
            onTabChange={handleTabChange}
            space={8}
            className={styles.style_tab}
            itemClassName={styles.style_tab_item}
            selectClassName={styles.tab_select}
            lineClassName={styles.line}
            textClassName={styles.tab_text}
        />
    );
};

FJModelFilterTabs.propTypes = {
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ).isRequired,
    activeFilter: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default FJModelFilterTabs;
